import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import FixedChatBar from './components/FixedChatBar';
import Header from './components/Header';
import ScrollManager from './components/ScrollManager';
import { SITE_NAME } from './constants/site';
import Disclaimer from './pages/Disclaimer';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsOfService from './pages/TermsOfService';

const PAGE_TITLES = {
  '/': `${SITE_NAME} — Design Software & Digital Marketing Tools`,
  '/privacy-policy': `Privacy Policy | ${SITE_NAME}`,
  '/terms-of-service': `Terms of Service | ${SITE_NAME}`,
  '/refund-policy': `Refund Policy | ${SITE_NAME}`,
  '/disclaimer': `Disclaimer | ${SITE_NAME}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || `Page Not Found | ${SITE_NAME}`;
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <DocumentTitle />
      <div className="fm-page">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FixedChatBar />
      </div>
    </BrowserRouter>
  );
}
